



























































































































/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable @typescript-eslint/no-unused-vars */
import Vue from "vue";

import { State, Action, Mutation } from "vuex-class";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import moment from "moment";
import momentTz from "moment-timezone";

import SudokuService from "../../../services/sudoku";
import { DailyRecord } from "../../../services/sudoku/sudoku.types";

const namespace = "sudoku";

@Component
export default class DailyRecords extends Vue {
  ss = SudokuService;

  indicators = {
    recordsLoading: false,
    creatingRecord: false,
    updateingRecord: false,
    deletingRecord: false
  };

  dialog = false;
  error: Error | null = null;
  headers = [
    {
      text: "User Id",
      align: "start",
      sortable: false,
      value: "user_id"
    },
    {
      text: "Username",
      align: "start",
      sortable: false,
      value: "name"
    },
    { text: "Time", value: "time" },
    { text: "Rank", value: "rank" },
    { text: "Date", value: "sudoku_id" },
    { text: "Actions", value: "actions", sortable: false }
  ];
  records: DailyRecord[] = [];
  editedIndex = -1;
  editedItem = {};
  defaultItem = {};
  sudokuDate = moment(new Date()).format("YYYY-MM-DD");
  sudokuPicker = false;

  mounted() {
    this.getRecords();
  }

  get getLoading() {
    return Object.values(this.indicators).filter(v => !!v).length > 0;
  }

  @Watch("sudokuDate")
  async getRecords() {
    this.indicators["recordsLoading"] = true;
    this.error = null;

    const filters = {
      sudoku_id: this.sudokuDate
    };

    return SudokuService.getRecords(filters)
      .then((records: DailyRecord[]) => (this.records = records))
      .catch((e: Error) => (this.error = e))
      .finally(() => (this.indicators["recordsLoading"] = false));
  }

  editItem(item: DailyRecord) {
    this.editedIndex = this.records.indexOf(item);
    this.editedItem = Object.assign({}, item);
    this.dialog = true;
  }

  createItem(item: DailyRecord) {
    this.indicators["creatingRecord"] = true;
    this.ss
      .createRecord(item)
      .then(this.getRecords)
      .catch(error => (this.error = error))
      .finally(() => (this.indicators["creatingRecord"] = false));
  }

  updateItem(item: DailyRecord) {
    this.indicators["updateingRecord"] = true;
    this.ss
      .updateRecord(item)
      .then(this.getRecords)
      .catch(error => (this.error = error))
      .finally(() => (this.indicators["updateingRecord"] = false));
  }

  deleteItem(item: DailyRecord) {
    if (confirm("Are you sure you want to delete this item?")) {
      this.indicators["deletingRecord"] = true;
      this.ss
        .deleteRecord(item)
        .then(this.getRecords)
        .catch(error => (this.error = error))
        .finally(() => (this.indicators["deletingRecord"] = false));
    }
  }

  close() {
    this.dialog = false;
    setTimeout(() => {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
    }, 300);
  }

  formatDate(d: Date): string {
    return moment(d).format("YYYY-MM-DD");
  }
}
